import Vue from 'vue'
import qs from 'qs'

export default {
    getUserFromToken(rootState, token, callbacks)   {
        Vue.axios.get(rootState.baseUrl + "/user/token/" +  token, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.user);
                }
            }
            else  {
                if (callbacks.fail)  {
                    callbacks.fail();
                }
            }
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
        });
    },
    getUser(rootState, userId, callbacks)   {
        Vue.axios.get(rootState.baseUrl + "/user/" +  userId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.user);
                }
            }
            else  {
                if (callbacks.fail)  {
                    callbacks.fail();
                }
            }
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
        });
    },
    userfirstUpdate(rootState, userId, updateInfo, callbacks)   {
        let params = qs.stringify({"data": JSON.stringify({
            "password": updateInfo.password,
            "firstname": updateInfo.firstname,
            "lastname": updateInfo.lastname
        })});
        Vue.axios.post(rootState.baseUrl + "/user/first-update/" +  userId, params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.user);
                }
            }
            else  {
                if (callbacks.fail)  {
                    callbacks.fail();
                }
            }
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
        });
    },
    userLogin(state, username, password, callbacks) {
        // Symfony 5.4 json_login expects JSON with username/password
        let params = {
            "username": username,
            "password": password
        };

        Vue.axios.post(state.loginUrl, params, {"headers": state.jsonHeaders}).then((response) => {
            if (response.status == 200)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            // defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            // defaultFailErrorCallback();
            return false;
        }); 
    },
    userRefresh(state, callbacks)  {
        let params = qs.stringify({
            "refresh_token": state.refreshToken
        });
        
        Vue.axios.post(state.refreshUrl, params, {"headers": state.postHeaders}).then((response) => {
            if (response.status == 200)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            // defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            // defaultFailErrorCallback();
            return false;
        }); 
    },
    userForgotPassword(state, username, callbacks)  {
        let params = qs.stringify({
            "username": username
        });


        Vue.axios.post(state.baseUrl + '/password/reset', params, {"headers": state.postHeaders}).then((response) => {
            if (response.status == 200)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            // defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            // defaultFailErrorCallback();
            return false;
        });
    },
    userChangePassword(state, newPassword, resetId, callbacks)  {
        let params = qs.stringify({
            "password": newPassword,
            "resetId": resetId
        });

        Vue.axios.post(state.baseUrl + '/password/change', params, {"headers": state.postHeaders}).then((response) => {
            if (response.status == 200)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.message);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            // defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            // defaultFailErrorCallback();
            return false;
        });
    }
};